// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#bsczhu2{position:relative;width:99%;height:100%;background-color:rgba(6,30,93,.5);box-sizing:border-box;margin-top:10px}#bsczhu2 .box{height:100%;width:100%}", ""]);
// Exports
module.exports = exports;
